/**
 * Un groupe de résultats de la palette Ctrl+K (en-tête de type + ses lignes).
 *
 * L'en-tête (« LOTS », « CUVÉES », « Récents »…) N'EST PAS sélectionnable : la
 * navigation clavier opère sur la liste APLATIE (les en-têtes sont sautés). Chaque
 * ligne connaît son index global via `startIndex + i`.
 */

import type { RechercheResultat } from "@champ-erp/contracts";

import { ResultatRecherche } from "./ResultatRecherche.js";

/** Groupe prêt à afficher (résultats serveur regroupés, ou bloc « Récents »). */
export interface GroupeAffiche {
  /** Clé React stable (type du groupe, ou "recents"). */
  cle: string;
  /** En-tête affiché du groupe. */
  libelle: string;
  resultats: RechercheResultat[];
}

export interface GroupeResultatsProps {
  groupe: GroupeAffiche;
  /** Index de la 1re ligne du groupe dans la liste aplatie. */
  startIndex: number;
  /** Index actuellement actif (surligné) dans la liste aplatie. */
  activeIndex: number;
  afficherType: boolean;
  onSelect: (resultat: RechercheResultat) => void;
  onSurvol: (index: number) => void;
}

export function GroupeResultats({
  groupe,
  startIndex,
  activeIndex,
  afficherType,
  onSelect,
  onSurvol,
}: GroupeResultatsProps) {
  return (
    <div role="group" aria-label={groupe.libelle}>
      <div className="px-4 pb-1 pt-3 text-[11px] font-semibold uppercase tracking-[0.08em] text-champagne-600">
        {groupe.libelle}
      </div>
      {groupe.resultats.map((resultat, i) => {
        const index = startIndex + i;
        return (
          <ResultatRecherche
            key={`${resultat.type}-${resultat.id}`}
            resultat={resultat}
            index={index}
            actif={index === activeIndex}
            afficherType={afficherType}
            onSelect={() => onSelect(resultat)}
            onSurvol={() => onSurvol(index)}
          />
        );
      })}
    </div>
  );
}
